import { cn } from "@/lib/utils"

import { ClipboardButton } from "./clipboard-button"

interface CopyableValueProps {
  /** Texto que vai para a área de transferência. */
  value: string
  /** Nome do campo, usado no rótulo acessível do botão ("Copiar transação"). */
  label: string
  /** Renderização alternativa do valor — um link, por exemplo. Sem isso sai como texto mono. */
  children?: React.ReactNode
  className?: string
}

/**
 * Valor de identificação com botão de cópia ao lado.
 *
 * Para os identificadores que ninguém digita: quem dá suporte cola `TRANS-9f1c5b7e-2c53-4d0f`
 * no chamado, no Kibana e na consulta do banco, e transcrever à mão erra.
 *
 * Use quando o valor fica DENTRO de uma linha de texto. Para o botão de cópia isolado (numa
 * célula de tabela, ao lado de um título), o `ClipboardButton` sozinho basta.
 */
export const CopyableValue = ({
  value,
  label,
  children,
  className,
}: CopyableValueProps) => (
  <span
    className={cn(
      "inline-flex min-w-0 items-center gap-1",
      className
    )}
  >
    {children ?? (
      <span className="break-all font-mono text-xs">
        {value}
      </span>
    )}
    <ClipboardButton
      text={value}
      label={label}
      variant="ghost"
      className="h-6 w-6 shrink-0"
    />
  </span>
)
